const STORAGE_KEY = "ai_love_voice_reminders";

export function loadReminders() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

export function saveReminders(list) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
}

export function addReminder({ content, remindAt, sourceText = "" }) {
  const item = {
    id: `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    content,
    remind_at: remindAt,
    source_text: sourceText,
    notified: false,
    created_at: new Date().toISOString(),
  };
  const list = loadReminders();
  list.push(item);
  saveReminders(list);
  return item;
}

export function deleteReminder(id) {
  saveReminders(loadReminders().filter((r) => r.id !== id));
}

export function markReminderNotified(id) {
  const list = loadReminders().map((r) =>
    r.id === id ? { ...r, notified: true } : r
  );
  saveReminders(list);
}

export function getPendingReminders(now = new Date()) {
  return loadReminders()
    .filter((r) => !r.notified && new Date(r.remind_at).getTime() <= now.getTime())
    .sort((a, b) => new Date(a.remind_at) - new Date(b.remind_at));
}

export function getUpcomingReminders() {
  const now = Date.now();
  return loadReminders()
    .filter((r) => !r.notified && new Date(r.remind_at).getTime() > now)
    .sort((a, b) => new Date(a.remind_at) - new Date(b.remind_at));
}
